import { Badge } from "@admin/components/atoms/Badge";
import { Button } from "@admin/components/atoms/Button";
import {
  controlsWithMultipleInstances,
  dateToISO,
  FoodControlPointInstanceDto,
  FoodManagementControls,
  InstanceStatus,
  isDisplayNameTypes,
  useControlPointTypeTranslations,
} from "@enos-monorepo/lib";
import { useTranslation } from "react-i18next";

interface AllControlsTableRowProps {
  instances: FoodControlPointInstanceDto[];
  setCurrentInstance: (instance: FoodControlPointInstanceDto) => void;
  openModal: (type: FoodManagementControls) => void;
}

export function AllControlsTableRow({
  instances,
  setCurrentInstance,
  openModal,
}: AllControlsTableRowProps) {
  const { t, i18n } = useTranslation();
  const controlPointTypeTranslations = useControlPointTypeTranslations();

  const completedInstances = instances.filter(
    (instance) =>
      instance.status === InstanceStatus.completed ||
      instance.status === InstanceStatus.completedWithErrors,
  );

  if (instances.length === 0) return null;

  const instance = instances[0];

  return (
    <tr key={instance.id}>
      <td className="text-center">
        <Badge type={completedInstances.length > 0 ? "success" : "warning"}>
          {completedInstances.length > 0
            ? `${completedInstances.length} ${t("food.Completed")}`
            : t("food.Waiting")}
        </Badge>
      </td>
      <td>
        {instance.controlPoint?.type &&
          (!isDisplayNameTypes(instance.controlPoint?.type)
            ? controlPointTypeTranslations[instance.controlPoint?.type]
            : instance.controlPoint?.name)}
      </td>
      <td className="text-center">
        {instance.endDate
          ? Intl.DateTimeFormat(i18n.language, {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }).format(new Date(instance.endDate))
          : t("food.No Date")}
      </td>
      <td className="text-center w-[120px]">
        <Button
          size="sm"
          disabled={
            completedInstances.length >= 1 &&
            instance.controlPoint?.type &&
            !controlsWithMultipleInstances.includes(instance.controlPoint?.type)
          }
          onClick={() => {
            setCurrentInstance({
              ...instance,
              updatedDate: dateToISO(new Date()),
            });
            if (instance.controlPoint) openModal(instance.controlPoint.type);
          }}
        >
          <i className="ki-filled ki-plus-squared"></i>
          {t("food.Entry")}
        </Button>
      </td>
    </tr>
  );
}
